export const getBasketFromLocalStorage = () => {
    const basket = localStorage.getItem('basket');
    return basket ? JSON.parse(basket) : {};
  };
  
  export const saveBasketToLocalStorage = (basket) => {
    localStorage.setItem('basket', JSON.stringify(basket));
  };
  